import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const usePostExternalIntegrationKeyFactsSettingsMutation = ({
	onError,
	onSuccess,
	impersonationContext,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: () => void;
	impersonationContext?: Api.IImpersonationContext;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({
			integrationProvider,
			keyFactsSettings,
		}: {
			integrationProvider: Api.IntegrationProvider;
			keyFactsSettings: Partial<Api.IKeyFactSettings>;
		}) => {
			return userSession.webServiceHelper.callAsync(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `integrations/${integrationProvider}/settings/keyfacts`,
				}),
				'POST',
				{
					...keyFactsSettings,
					_type: `${integrationProvider}KeyFactSettings`,
				}
			);
		},
		onError,
		onSuccess,
	});
};
